import { css } from '@emotion/react';
import { ContentLoader } from '@frontend/design-system';
import { ScheduleKnowledgeForm } from './schedule-knowledge-form';

type Props = {
  locationId: string;
  isLoading?: boolean;
};

export const SingleLocationScheduleKnowledge = ({ locationId, isLoading }: Props) => {
  return (
    <div css={styles.container}>
      <ContentLoader show={isLoading} />
      <ScheduleKnowledgeForm locationId={locationId} />
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-lg);
    padding: var(--fabric-space-gap-lg);
    background-color: var(--fabric-color-surface-default);
    box-shadow: var(--fabric-card-shadow);
    border-radius: var(--fabric-radius-md);
    max-width: 700px;
    position: relative;
  `,
};
